export default __webpack_public_path__ + "static/media/Group7554.0c989beb.png";